import { Node } from "reactflow"
import { graphUrlAddNode } from "@features/graph/utils/graphUrl"
import { Button } from "@mui/material"
import { useSetNodeSelection } from "@features/graph/state/graphAtoms"

export const AddToSelectionButton = (props: { selectedNode: Node | undefined }) => {
  const { addNode } = useSetNodeSelection()

  const onAddSelection: React.MouseEventHandler = (e) => {
    if (props.selectedNode === undefined) return
    e.stopPropagation()

    const node = props.selectedNode
    addNode(node)
    graphUrlAddNode(node.data.display.label)
  }

  return (
    <Button
      onClick={onAddSelection}
      sx={{
        m: "4px",
        width: "30%",
        borderRadius: "3px !important",
        backgroundColor: "rgba(40,40,43, 0.9)",
      }}
      variant="contained"
    >
      Add to selection
    </Button>
  )
}
